<template>
  <div class="drawCode">
    <div class="left">
      <img :src="imgurl" />
    </div>
    <div class="right">
      <i class="el-icon-refresh-right" @click="toCode"></i>
    </div>
  </div>
</template>
<script>
export default {
  name: "drawCode",
  props: ["imgurl"],
  components: {},
  data: () => {
    return {};
  },
  methods: {
    toCode() {
      this.$emit("getCodeFn");
    },
  },
};
</script>
<style scoped>
.drawCode {
  padding-left: 5px;
  display: flex;
  align-items: center;
}
.drawCode > .left {
  /* width: 120px; */
  flex: 1;
  height: 40px;
  /* background: pink; */
}
.drawCode > .left > img {
  width: 100%;
  height: 100%;
}
.drawCode > .right {
  width: 17px;
  margin-left: 5px;
}
.drawCode > .right > .el-icon-refresh-right {
  font-size: 17px;
  color: #04b5c4;
  cursor: pointer;
}
</style>
